import type { AccountInfo } from '@azure/msal-common';
import { Maybe } from '@precon-tools-suite-by-shared/js-utils';
import { toUpper } from 'lodash';

export function getB2CTenantName(
    accountInfo: AccountInfo | null | undefined
): Maybe<string> {
    if (!accountInfo || !accountInfo.environment) return Maybe.empty();

    const matches = /^(?<tenantName>[a-z]+)\.b2clogin\.com$/.exec(
        accountInfo.environment
    );

    if (matches && matches.groups?.tenantName) {
        return Maybe.pure(matches.groups.tenantName);
    }

    return Maybe.empty();
}

export function getPolicyUriFromAccountInfo(
    accountInfo: AccountInfo | null | undefined,
    policy: string
): Maybe<string> {
    return getB2CTenantName(accountInfo).bind(
        (tenantName) =>
            `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/${toUpper(
                policy
            )}`
    );
}
